import _, { isEmpty } from 'lodash';
import React from 'react';
import moment from 'moment';
import { ReactComponent as VymoAppIcon } from 'src/assets/icons/vymoAppIcon.svg';
import { AuditHistoryItem } from './types';
import styles from './index.module.scss';

export const processTimeStamp = (timeStamp) => {
  const formattedDate = moment(timeStamp).format('MMM DD, YYYY'); // Oct 04, 2024
  const formattedTime = moment(timeStamp).format('hh:mm A');

  return { formattedTime, formattedDate };
};

export const mapInputsToFormValues = (inputsMap) => {
  const valuesMap = {};

  if (!isEmpty(inputsMap)) {
    Object.keys(inputsMap).forEach((key) => {
      valuesMap[key] = {
        value: inputsMap[key],
      };
    });
  }

  return valuesMap;
};

export const getModificationTag = (type) => {
  switch (type) {
    case 'vymo':
    default:
      return (
        <>
          Modified on Vymo
          <VymoAppIcon className={styles.history__icon} />
        </>
      );
  }
};

export const parseHistoryDate = (dateString?: string) => {
  if (!dateString) {
    return moment.invalid();
  }

  return moment(
    dateString,
    ['DD-MM-YYYY', 'ddd, MMM D, YYYY', 'YYYY-MM-DD'],
    true,
  );
};

export const getGroupedHistories = (histories: AuditHistoryItem[] = []) => {
  const groupedByDate = _.groupBy(histories, (history) => history?.date || '');

  const sortedDates = Object.keys(groupedByDate).sort(
    (firstDate, secondDate) => {
      const secondTimestamp = parseHistoryDate(secondDate).valueOf();
      const firstTimestamp = parseHistoryDate(firstDate).valueOf();
      return secondTimestamp - firstTimestamp;
    },
  );

  return sortedDates.map((date) => ({
    date,
    histories: groupedByDate[date] || [],
  }));
};
